export function validateRateAgreement(rate) {
  const errors = {};

  if (!rate.name?.trim()) {
    errors.name = "Ingrese el nombre del acuerdo.";
  }

  const number = Number(rate.number);
  if (!rate.number) {
    errors.number = "Ingrese el número del acuerdo.";
  } else if (number <= 0) {
    errors.number = "El número debe ser mayor que cero.";
  }

  if (!/^\d{4}$/.test(rate.year)) {
    errors.year = "El año debe tener exactamente 4 dígitos.";
  }

  if (!rate.issued_at) {
    errors.issued_at = "Seleccione la fecha de expedición.";
  }

  if (!rate.effective_from) {
    errors.effective_from = "Seleccione la fecha de inicio.";
  }

  if (
    !rate.no_end_date &&
    rate.effective_from &&
    rate.effective_to &&
    new Date(rate.effective_to) < new Date(rate.effective_from)
  ) {
    errors.effective_to = "Revise la fecha final.";
    errors.date_range =
      "La fecha final no puede ser anterior a la fecha de inicio.";
  }

  if (rate.document_url) {
    try {
      new URL(rate.document_url);
    } catch {
      errors.document_url = "Ingrese una URL válida.";
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}
